// generated by the plop

import { PROGRESS_STATUSES } from 'symbols';

export interface PreparingForUseStateModel {
  registrationStatus: PROGRESS_STATUSES;
}

export const PREPARING_FOR_USE_STATE_DEFAULT: PreparingForUseStateModel = {
  registrationStatus: PROGRESS_STATUSES.NOT_INITIALIZED
};
